import {Pipe, PipeTransform} from '@angular/core';
import {isOwner} from '@shared/helpers/auth';

@Pipe({
  name: 'hasPermission'
})
export class HasPermissionPipe implements PipeTransform {

  transform(value: string, level = 'admin'): unknown {
    if (level === 'owner' ) {
      return !!isOwner(value);
    }
    return false;
  }

}
